import { styled } from 'styled-components';
import SmartImage from '../../../components/smartimage/SmartImage';

export const SectionContainer = styled.div`
  margin-top: 20px;
`

export const Title = styled.h1`
  margin-bottom: 20px;
`

export const Img = styled(SmartImage)`
  width: 90%;
  height: auto;
  object-fit: contain;
`